module.exports = __webpack_public_path__ + "img/banner1.922c58e6.svg";